import React, { PureComponent } from "react";
import { BarChart, Bar, Cell, XAxis, YAxis, Tooltip } from "recharts";

import styles from "./style.module.css";

export default class ExplainBarChart extends PureComponent {
  render() {
    const { bars, unit, dKey } = this.props;

    if (bars === undefined) {
      return <div />;
    }

    return (
      <div className={styles.tinyBarChart}>
        <BarChart
          width={380}
          height={50}
          data={bars}
          layout={"vertical"}
          margin={{ top: 0, right: 20, bottom: 10, left: 0 }}
        >
          <XAxis dataKey={dKey} type={"number"} domain={[0, "dataMax"]} hide unit={unit} />
          <YAxis dataKey={"label"} type={"category"} hide />
          <Tooltip />
          <Bar dataKey={dKey}>
            {bars.map((p, index) => (
              <Cell key={index} fill={index === 0 ? "#7E69D7" : "#E0E0E0"} />
            ))}
          </Bar>
        </BarChart>
      </div>
    );
  }
}
